import * as tslib_1 from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import Header from '@/components/shared/header/header.vue';
import Aside from '@/components/apps/aside/aside.vue';
let CommonView = class CommonView extends Vue {
    //weiyaos
    get IsNavigation() {
        return window.sessionStorage.getItem('IsNavigation');
    }
};
CommonView = tslib_1.__decorate([
    Component({
        name: 'common-view',
        components: {
            Aside,
            Header
        }
    })
], CommonView);
export default CommonView;
